
const digest = '814daafd437fbc70c4ee5ce70d75a4df278cb440982c17620ecd5aab2f57378a';
const classes = {"wrapper":"_wrapper_crf39_1","right":"_right_crf39_10","left":"_left_crf39_14","small":"_small_crf39_18","header":"_header_crf39_31","title":"_title_crf39_40","closeButton":"_closeButton_crf39_48","content":"_content_crf39_63"};
const css = `._wrapper_crf39_1 {
  position: absolute;
  top: 0;
  width: 400px;
  max-width: 100%;
  height: 100%;
  z-index: 1050;
}

._wrapper_crf39_1._right_crf39_10 {
  right: 0;
}

._wrapper_crf39_1._left_crf39_14 {
  left: 0;
}

._small_crf39_18 {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  background-color: #fff;
  z-index: 1;
  display: flex;
  flex-direction: column;
  box-shadow: 0px 0px 41px 9px rgba(0, 0, 0, 0.2);
}

._header_crf39_31 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 19px;
  border-bottom: 1px solid #eaedf3;
  background-color: #fff;
}

._title_crf39_40 {
  font-weight: 500;
  font-size: 18px;
  color: #000000;
  margin: 0;
  font-family: Rubik, sans-serif;
}

._closeButton_crf39_48 {
  cursor: pointer;
  background: none;
  border: none;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

._closeButton_crf39_48 img {
  width: 16px;
  height: 16px;
}

._content_crf39_63 {
  flex: 1;
  padding: 24px;
  overflow-y: auto;
  background-color: #fff;
}

@media (max-width: 400px) {
  ._wrapper_crf39_1 {
    width: 100vw;
  }
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  